import React from 'react'
import PropTypes from 'prop-types'

import {
  Grid,
  SvgIcon,
  Typography,
} from '@material-ui/core'
import { mdiUndo } from '@mdi/js'
import { withStyles } from '@material-ui/core/styles'

class AccessListEmptyState extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    classes: PropTypes.object.isRequired,
  }

  static styles = () => ({
    container: {
      margin: 0,
      width: '100%',
      padding: '0 65px 0 0',
    },
    arrow: {
      height: 48,
      width: 'auto',
      webkitTransform: 'rotate(130deg)',
      mozTransform: 'rotate(130deg)',
      msTransform: 'rotate(130deg)',
      oTransform: 'rotate(130deg)',
      transform: 'rotate(130deg)',
    },
  })

  render() {
    const { classes } = this.props

    return (
      <Grid container spacing={2} className={classes.container}>
        <Grid item xs>
          <Typography variant="subtitle1" align="right">
            { this.props.children }
          </Typography>
        </Grid>
        <Grid item>
          <SvgIcon className={classes.arrow}>
            <path d={mdiUndo} />
          </SvgIcon>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(AccessListEmptyState.styles)(AccessListEmptyState)
